import { getWeek as getWeekBase } from 'date-fns'

export function getWeek(locale: Locale) {
  return (date: Date) => getWeekBase(date, { locale, weekStartsOn: 1 })
}
